// extracted by mini-css-extract-plugin
module.exports = {"EledoPropertyList":"EledoPropertyList_EledoPropertyList__2CKAH","addRowButton":"EledoPropertyList_addRowButton__1ap9m"};